import { useFormikContext } from 'formik';
import type { ButtonHTMLAttributes, ReactNode } from 'react';

import { Button } from '@components/Button/Button';
import type { IconName } from '@components/Icon/Icon';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
	children: ReactNode;
	fullWidth?: boolean;
	isLoading?: boolean;
	primary?: boolean;
	uppercase?: boolean;
	disabled?: boolean;
	icon?: IconName;
	iconColor?: string;
	className?: string;
	style?: React.CSSProperties;
	onlyValidPress?: boolean;
}

const SubmitButton: React.FC<Props> = ({ disabled = false, onlyValidPress = false, primary = true, ...props }) => {
	const { handleSubmit, isValid } = useFormikContext();

	return (
		<Button primary={primary} {...props} disabled={disabled || (onlyValidPress && !isValid)} onClick={() => handleSubmit()} type="button" />
	);
};

export default SubmitButton;
